module.exports = __webpack_public_path__ + "static/img/banner-m.54f03c9f.jpg";